module.exports = __webpack_public_path__ + "img/ep-fleur4.68d92570.jpg";